import { useCallback, useRef } from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import TableCreatorTableTitle from "@FillInTableContainer/shared/components/TableCreatorTableTitle/TableCreatorTableTitle";
import { TableCreatorGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";

import DealLaScSingleGroupShell from "./components/DealLaScSingleGroupShell/DealLaScSingleGroupShell";
import * as S from "./DealLaScSingleTable.style";
import { useHandleDealLaScSingleTableCreatorTable } from "./hooks/useHandleDealLaScSingleTableCreatorTable";

interface Props {
  groupTableKey: DealLaScSection;
  tableKey: string | null;
  groupShellList: TableCreatorGroupShellList;
  groupTableIndex: number;
  tableIndex: number;
  customTableDeleteEvent?: () => void;
}

const DealLaScSingleTable = ({
  groupShellList,
  groupTableIndex,
  tableIndex,
  tableKey,
  groupTableKey,
  customTableDeleteEvent,
}: Props) => {
  const groupShellRef = useRef<HTMLDivElement[]>([]);

  const tablePropsInfo: Props = {
    groupTableKey,
    tableKey,
    groupTableIndex,
    tableIndex,
    groupShellList,
  };

  const { focusStatus, isFocused } =
    useHandleDealLaScSingleTableCreatorTable(tablePropsInfo);

  const addToRefs = useCallback((element: HTMLDivElement) => {
    groupShellRef.current.push(element);
  }, []);

  const isClearTable =
    isFocused &&
    focusStatus.type === "clear" &&
    focusStatus.container === "table";

  return (
    <S.TableWrapper isFocused={isFocused} isClearTable={isClearTable}>
      <TableCreatorTableTitle
        articleSectionKey={ENTRY_DATA_SECTION_KEYS.dealsLaSc}
        tableKey={tableKey}
        groupTableKey={groupTableKey}
        groupTableIndex={groupTableIndex}
        tableIndex={tableIndex}
        isDragging={isFocused && focusStatus.type === "dragging"}
        titleWrapperColor="#F8F9FA"
      />
      {groupShellList.map(
        ({ groupShellKey, shellList }, groupShellListIndex) => (
          <S.GroupShellWrapper
            ref={addToRefs}
            key={`groupShellList-${String(groupShellListIndex)}`}
          >
            <DealLaScSingleGroupShell
              customTableDeleteEvent={customTableDeleteEvent}
              shellList={shellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableKey={tableKey}
              tableIndex={tableIndex}
              groupShellKey={groupShellKey}
              groupShellIndex={groupShellListIndex}
            />
          </S.GroupShellWrapper>
        ),
      )}
    </S.TableWrapper>
  );
};

export default DealLaScSingleTable;
